import Box from "../Box";
import ProgressText from "./ProgressText";
import RecorderIconButton from "./RecorderIconButton";
import TimerChip from "./Timer";
import type { AudioRecorderState, AudioRecorderType } from "./index";

type Props = {
	state: AudioRecorderState;
	type: AudioRecorderType;
	progressText: string;
	remainingSeconds: number;
	formatTimerLabel?: (seconds: number) => string;
	showDiscardButton: boolean;
	allowStopWhileRecording?: boolean;
	isLoading: boolean;
	disabled: boolean;
	handleRecord: () => void;
	handleDelete?: () => void;
};

const RecorderTrailing = ({
	state,
	type,
	progressText,
	remainingSeconds,
	formatTimerLabel,
	showDiscardButton,
	allowStopWhileRecording,
	isLoading,
	disabled,
	handleRecord,
	handleDelete,
}: Props) => {
	const isAutoRecord = type === "autoRecord";

	if (isAutoRecord) {
		if (state === "default") {
			if (disabled) {
				return null;
			}
			return (
				<TimerChip seconds={remainingSeconds} formatLabel={formatTimerLabel} />
			);
		}
		if (!(state === "recording" && allowStopWhileRecording)) {
			return <ProgressText text={progressText} showClockIcon />;
		}
	}

	if (state === "recorded") {
		return (
			<Box flexDirection="row" alignItems="center" gap={16}>
				<ProgressText text={progressText} />
				{showDiscardButton && handleDelete && (
					<RecorderIconButton
						variant="outlined"
						icon="close"
						onPress={handleDelete}
						disabled={disabled}
						a11yLabel="Discard recording"
					/>
				)}
			</Box>
		);
	}

	if (state === "recording") {
		return (
			<Box flexDirection="row" alignItems="center" gap={16}>
				<ProgressText text={progressText} />
				<RecorderIconButton
					variant="filled"
					icon="pause"
					onPress={handleRecord}
					loading={isLoading}
					disabled={disabled}
					a11yLabel="Stop recording"
				/>
			</Box>
		);
	}

	if (disabled && state === "default") {
		return null;
	}

	return (
		<Box flexDirection="row" alignItems="center" gap={16}>
			<ProgressText text={progressText} />
			<RecorderIconButton
				variant="filled"
				icon="microphone"
				onPress={handleRecord}
				loading={isLoading}
				disabled={disabled || state === "expired"}
				a11yLabel="Start recording"
			/>
		</Box>
	);
};

export default RecorderTrailing;
